"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SIGN_OUT_ALL_DEVICES_MUTATION = "\nmutation SignOutAllDevices($appId: AppId!) {\n  signOutAllDevices(appId: $appId) {\n    id\n    lastSeen\n    deviceType\n    isCurrent\n    deviceDescription\n    sessionId\n  }\n}\n";
exports.default = SIGN_OUT_ALL_DEVICES_MUTATION;
//# sourceMappingURL=signOutAllDevices.js.map